import type { ReactNode } from 'react';
import SubPageContent from '@/components/layout/SubPageContent';
import { punchingMetalBackgroundImage } from '@/utils/publicHeroFile';

type SubPageHeaderProps = {
  children: ReactNode;
};

/** 下層ページ上部ヘッダー（トップヒーローと同じパンチングメタル背景） */
export default function SubPageHeader({ children }: SubPageHeaderProps) {
  return (
    <section className="relative w-full overflow-hidden bg-[#0e0e0e] pt-40 pb-20 md:pt-48 md:pb-24">
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 z-0 bg-[#0e0e0e] bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: punchingMetalBackgroundImage() }}
      />
      <div aria-hidden className="pointer-events-none absolute inset-0 z-[1] bg-black/45" />
      <div className="relative z-10">
        <SubPageContent>{children}</SubPageContent>
      </div>
    </section>
  );
}
